export type DeprecatedCustomerBillingRoutePageId =
  | "billing-profiles-2"
  | "contracts"
  | "contracts-2"
  | "contracts:list-2"
  | "contracts:create-2"
  | "contracts:edit-2"
  | "contracts:view-2"
  | "contracts:view-vendor-contract-2"
  | "isv-solutions-2"
  | "isv-solutions:create-2"
  | "isv-solutions:edit-2"
  | "isv-solutions:view-2"
  | "invoices-2"
  | "invoices:details-2"
  | "credits:customer-2"
  | "adjustments:customer-2"
  | "orders-2";

export type DeprecatedCustomerBillingRouteConfig = {
  pageId: DeprecatedCustomerBillingRoutePageId;
  route: string;
};

export const deprecatedCustomerBillingRoutes: DeprecatedCustomerBillingRouteConfig[] = [
  {
    pageId: "billing-profiles-2",
    route: "/billing-profiles",
  },
  {
    pageId: "contracts-2",
    route: "/contracts",
  },
  {
    pageId: "contracts:list-2",
    route: "/contracts/contracts-list",
  },
  {
    // Route removed because it's redundant
    pageId: "contracts",
    route: "/billing/contracts/contracts-list",
  },
  {
    pageId: "contracts:create-2",
    route: "/contracts/contracts-list/create",
  },
  {
    pageId: "contracts:edit-2",
    route: "/contracts/contracts-list/:contractId",
  },
  {
    pageId: "contracts:view-2",
    route: "/contracts/contracts-list/:contractId/view",
  },
  {
    pageId: "contracts:view-vendor-contract-2",
    route: "/contracts/contracts-list/:contractId/view-vendor-contract",
  },
  {
    pageId: "invoices-2",
    route: "/invoices",
  },
  {
    pageId: "invoices:details-2",
    route: "/invoices/:eid/:ivnum",
  },
  {
    pageId: "isv-solutions-2",
    route: "/isv-solutions",
  },
  {
    pageId: "isv-solutions:create-2",
    route: "/isv-solutions/create",
  },
  {
    pageId: "isv-solutions:edit-2",
    route: "/isv-solutions/edit/:perkId",
  },
  {
    pageId: "isv-solutions:view-2",
    route: "/isv-solutions/:perkId",
  },
  {
    pageId: "orders-2",
    route: "/orders",
  },
  {
    pageId: "credits:customer-2",
    route: "/credits",
  },
  {
    pageId: "adjustments:customer-2",
    route: "/adjustments",
  },
];
